<template>
  <div>
    <img src="img/avatars/8.jpg" class="img-avatar" alt="Avatar">
    <div><strong>JOHN DOE</strong></div>
    <div class="text-muted"><small>Founder &amp; CEO</small></div>
    <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
      <button type="button" class="btn btn-link">
        <i class="icon-settings"></i>
      </button>
      <button type="button" class="btn btn-link">
        <i class="icon-speech"></i>
      </button>
      <button type="button" class="btn btn-link">
        <i class="icon-user"></i>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DefaultSidebarHeader'
}
</script>
